function find(arr, cb) {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    return undefined;
  }

  if (typeof cb !== 'function') {
    const keys = Object.keys(cb);
    return arr.find(item => keys.every(key => item[key] === cb[key]));
  }

  return arr.find(cb);
}

module.exports = find;



// WEBPACK FOOTER //
// ./src/utils/find.js